import COLORS from '../../../utils/constants/colors'

const gameResultSectionStyles = () => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
    backgroundColor: '#F7F6F4',
    borderRadius: 12,
    padding: '14px 16px',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  headerIcon: {
    color: '#7A7A7A',
  },
  resultText: {
    fontSize: 15,
    fontWeight: 600,
    color: '#3C3C3C',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
  },
  dangerText: {
    color: COLORS.red,
  },
  panel: {
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
    paddingTop: 6,
    borderTop: '1px solid #ECECEC',
  },
  scoreRow: {
    display: 'flex',
    gap: 16,
    alignItems: 'flex-end',
  },
  scoreCell: {
    flex: 1,
  },
  scoreField: {
    '& .MuiInputBase-root': {
      backgroundColor: COLORS.white,
      border: '1px solid #E3E1DE',
    },
  },
  teamLabel: {
    fontSize: 12,
    color: '#9A9A9A',
    marginBottom: 4,
  },
  switchRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  switchText: {
    flex: 1,
  },
  hint: {
    fontSize: 12,
    color: '#9A9A9A',
  },
  error: {
    fontSize: 12,
    color: COLORS.red,
  },
  confirmBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    backgroundColor: COLORS.white,
    border: '1px solid #E3E1DE',
    borderRadius: 8,
    padding: '12px 14px',
  },
  confirmBoxDanger: {
    borderColor: COLORS.red,
  },
  confirmText: {
    fontSize: 13,
    color: '#5C5C5C',
  },
  panelActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
  },
})

export default gameResultSectionStyles
